import React from "react";
import { FaGithub, FaLink, FaNodeJs } from "react-icons/fa";
import {
  ProjectDiv,
  Row,
  ServiceBox,
  ServiceBoxHeader,
  ServiceBoxP,
  A,
  BoxDiv
} from "./Styles";
import { Container, Common, H1 } from "../../SharedStyles/SharedStyles";
import { AiFillGithub } from "react-icons/ai";
import { FaHtml5, FaReact, FaJs, FaCss3 } from "react-icons/fa";
import { SiMongodb, SiNodeDotJs, SiRedux, SiHeroku } from "react-icons/si";
// import { SiExpress, SiMaterialui } from 'react-icons/si/SiExpress';

import { v4 as uuidv4 } from "uuid";

const Projects = () => {
  const projects = [
    {
      id: 1,
      project_name: "AJIO clone",
      image: `https://teal-buttercream-d17c84.netlify.app/static/media/ajiogif.9fa499981ac1ef4495c3.gif`,
      project_desc:
        "AJIO, a fashion and lifestyle brand, is Reliance Retail’s digital commerce initiative and is the ultimate fashion destination for styles",
      deploy_link: "https://hopeful-williams-fd227e.netlify.app/",
      repo_link: "https://github.com/tarun10001/Ajio-Clone",
      tech_stack: [
        <FaHtml5 />,
        <FaCss3 />,
        <FaJs />,
        <SiMongodb />,
        <FaNodeJs />
      ]
    },
    {
      id: 2,
      project_name: "YouTube Clone",
      image:
        "https://teal-buttercream-d17c84.netlify.app/static/media/ytgif.7d65a3e72013e22280e5.gif",
      project_desc:
        "This is a clone of YouTube - The Online video sharing and social media platform created using the API from googleapis.com.",
      deploy_link: "https://upbeat-hodgkin-4043fc.netlify.app/",
      repo_link: "https://github.com/tarun10001/Youtube-Clone",
      tech_stack: [<FaHtml5 />, <FaCss3 />, <FaJs />]
    },
    {
      id: 3,
      project_name: "Overstock clone",
      image:
        "https://teal-buttercream-d17c84.netlify.app/static/media/overstockgif.74fb444181e7313faa0b.gif",
      project_desc:
        "Overstock.com is an internet retailer sells home decor, furniture, bedding, and many other goods that are closeout merchandise.",
      deploy_link: "https://overstockcloneproj.netlify.app/",
      repo_link: "https://github.com/tarun10001/overstock_project",
      tech_stack: [<FaHtml5 />, <FaCss3 />, <FaJs />]
    },
    {
      id: 4,
      project_name: "Movie-App",
      image:
        "https://github.com/tarun10001/Movie-App/blob/main/moviegif.gif?raw=true",
      project_desc:
        "A Movie app where you can search movies and this page is built by using HTML, CSS & Advanced js that usees TMDB API.",
      deploy_link: "https://agitated-curie-fd4a77.netlify.app/",
      repo_link: "https://github.com/tarun10001/Movie-App",
      tech_stack: [<FaHtml5 />, <FaCss3 />, <FaJs />]
    },
    {
      id: 5,
      project_name: "Weather App",
      image:
        "https://github.com/tarun10001/Weather-find-App/blob/main/weathergif.gif?raw=true",
      project_desc:
        "A simple App which is used for Seven Days forecasting weather and location which shows tempterature and wind Speed.",
      deploy_link: "https://golden-capybara-ef9a2c.netlify.app/",
      repo_link: "https://github.com/tarun10001/Weather-find-App",
      tech_stack: [<FaHtml5 />, <FaCss3 />, <FaJs />]
    }
  ];

  return (
    <Container className="projects">
      <ProjectDiv>
        <Common>
          <H1>Projects</H1>
        </Common>
        <Row>
          {projects.map((item) => (
            <BoxDiv key={uuidv4()}>
              <ServiceBox>
                <img src={item.image} alt="icon" style={{ width: "100%" }} />
                <div style={{ margin: "25px" }}>
                  <ServiceBoxHeader style={{ textAlign: "center" }}>
                    {item.project_name}
                  </ServiceBoxHeader>
                  <ServiceBoxP>{item.project_desc}</ServiceBoxP>
                  {/* <a href="">Read more</a> */}
                  <div
                    style={{
                      margin: "20px",
                      display: "flex",
                      justifyContent: "center"
                    }}
                  >
                    {item.tech_stack.map((item) => (
                      <div key={uuidv4()} className="iconsTechStack">
                        {item}
                      </div>
                    ))}
                  </div>
                  <A
                    href={item.repo_link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaGithub /> Code
                  </A>
                  <A
                    href={item.deploy_link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLink /> Demo
                  </A>
                </div>
              </ServiceBox>
            </BoxDiv>
          ))}
        </Row>
      </ProjectDiv>
    </Container>
  );
};

export default Projects;
